//====================================================
//  Function: Slider
//====================================================
function componentSwiper() {
  // workSlider()
  aboutMeSlider()
  addonsSlider()
  instagramSlider()
}

function workSlider() {
  if ($('.js-slider-work').length) {
    var inst = $('.js-slider-work'),
      swiperBlock = inst.closest('.js-slider-group'),
      swiperArrowPrev = swiperBlock.find('.js-swiper-arrow-prev'),
      swiperArrowNext = swiperBlock.find('.js-swiper-arrow-next')

    var mySwiperWork = new Swiper(inst, {
      slidesPerView: 1,
      spaceBetween: 0,
      lazy: true,
      loop: true,
      speed: 600,
      autoplay: {
        delay: 2000,
        disableOnInteraction: true,
      },
      navigation: {
        nextEl: swiperArrowNext,
        prevEl: swiperArrowPrev,
      },
    })

    mySwiperWork.on('slideChange', function () {
      var id = mySwiperWork.realIndex
      $('.tablet-window-referencies .js-tab-list-item').removeClass('is-active')
      $(
        '.tablet-window-referencies .js-tab-list-item[data-id="tab-' +
          id +
          '"]',
      ).addClass('is-active')
    })
  }
}

var interleaveOffset = 0.5
function aboutMeSlider() {
  if ($('.js-slider-about-me').length) {
    var inst = $('.js-slider-about-me'),
      swiperBlock = inst.closest('.js-slider-group'),
      swiperArrowPrev = swiperBlock.find('.js-swiper-arrow-prev'),
      swiperArrowNext = swiperBlock.find('.js-swiper-arrow-next')

    var mySwiperAbout = new Swiper(inst, {
      slidesPerView: 1,
      spaceBetween: 0,
      lazy: true,
      loop: true,
      speed: 600,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      navigation: {
        nextEl: swiperArrowNext,
        prevEl: swiperArrowPrev,
      },
      on: {
        progress: function () {
          var swiper = this
          for (var i = 0; i < swiper.slides.length; i++) {
            var slideProgress = swiper.slides[i].progress
            var innerOffset = swiper.width * interleaveOffset
            var innerTranslate = slideProgress * innerOffset
            swiper.slides[i].querySelector('.about-slide-img').style.transform =
              'translate3d(' + innerTranslate + 'px, 0, 0)'
          }
        },
        touchStart: function () {
          var swiper = this
          for (var i = 0; i < swiper.slides.length; i++) {
            swiper.slides[i].style.transition = ''
          }
        },
        setTransition: function (speed) {
          var swiper = this
          for (var i = 0; i < swiper.slides.length; i++) {
            swiper.slides[i].style.transition = speed + 'ms'
            swiper.slides[i].querySelector(
              '.about-slide-img',
            ).style.transition = speed + 'ms'
          }
        },
      },
    })
  }
}

function addonsSlider() {
  if ($('.js-slider-addons').length) {
    var inst = $('.js-slider-addons'),
      swiperBlock = inst.closest('.js-slider-group'),
      swiperArrowPrev = swiperBlock.find('.js-swiper-arrow-prev'),
      swiperArrowNext = swiperBlock.find('.js-swiper-arrow-next')

    var mySwiper = new Swiper(inst, {
      slidesPerView: 1,
      spaceBetween: 0,
      lazy: true,
      loop: true,
      speed: 600,
      navigation: {
        nextEl: swiperArrowNext,
        prevEl: swiperArrowPrev,
      },
    })
  }
}

function instagramSlider() {
  if ($('.js-slider-instagram').length) {
    var inst = $('.js-slider-instagram'),
      swiperBlock = inst.closest('.js-slider-group')

    var mySwiper = new Swiper(inst, {
      lazy: true,
      loop: true,
      speed: 600,
      spaceBetween: 0,
      slidesPerView: 6,
      speed: 5000,
      autoplay: {
        delay: 1,
        disableOnInteraction: true,
      },
      breakpoints: {
        1600: {
          slidesPerView: 5,
        },
        1400: {
          slidesPerView: 4,
        },
        1200: {
          slidesPerView: 3,
        },
        992: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 2,
        },
        576: {
          slidesPerView: 2,
        },
        200: {
          slidesPerView: 2,
        },
      },
    })
  }
}
